import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import type { GuidanceMode, GuidanceState } from '~/utils/guidanceTypes'
import { NOTICE_TYPE_TO_STATE } from '~/utils/guidanceTypes'
import Notice from '~/entities/Notice'
// GuidanceInline, GuidanceBanner, GuidanceHelper are auto-imported by Nuxt


export default /*#__PURE__*/_defineComponent({
  __name: 'Guidance',
  props: {
    mode: { default: 'banner' },
    state: { default: undefined },
    message: { default: '' },
    expletive: { default: '' },
    dismissable: { type: [Boolean, null], default: undefined },
    replacements: { default: () => ({}) },
    notice: { default: null },
    icon: { default: undefined },
    summaryLine: { default: '' },
    badgeText: { default: '' },
    detailTitle: { default: '' },
    details: { default: '' },
    tip: { default: '' },
    limits: { default: () => [] },
    limitsLabel: { default: 'Limits' },
    expanded: { type: Boolean, default: undefined }
  },
  emits: ["dismiss"],
  setup(__props: any) {

const props = __props as { mode: GuidanceMode, state: GuidanceState, message: string, expletive: string, dismissable: boolean | undefined, replacements: Record<string, string>, notice: InstanceType<typeof Notice> | null, icon: [string, string] | null, summaryLine: string, badgeText: string, detailTitle: string, details: string, tip: string, limits: Array<{ label: string; value: string }>, limitsLabel: string, expanded: boolean }





// Notice adapter: derive values from Notice entity, explicit props take priority
const resolvedState = computed<GuidanceState>(() => {
  if (props.state) return props.state
  if (props.notice?.type) {
    return NOTICE_TYPE_TO_STATE[props.notice.type] || 'safe'
  }
  return 'safe'
})

const resolvedMessage = computed(() => {
  if (props.message) return props.message
  return props.notice?.message || ''
})

const resolvedExpletive = computed(() => {
  if (props.expletive) return props.expletive
  return props.notice?.expletive || ''
})

const resolvedDismissable = computed(() => {
  if (props.dismissable !== undefined) return props.dismissable
  return props.notice?.dismissable || false
})

const resolvedReplacements = computed(() => {
  const noticeReplacements = props.notice?.replacements || {}
  return { ...noticeReplacements, ...props.replacements }
})

return { __sfc: true,props, resolvedState, resolvedMessage, resolvedExpletive, resolvedDismissable, resolvedReplacements }
}

})